import { awaitDataServiceFetcher } from '@dxb-web-ui-framework/common/domain/RestfulDataTransfer/DataService/DataServiceFetchers';
import { IInternationalizationRepository } from '../entities/IInternationalizationRepository';
import { Locale, Translation } from '../entities';
import { translationsResponseDTOToTranslationsAdapter } from './translationsResponseDTOToTranslationsAdapter';
import { culturesResponseDTOToLocalesAdapter } from './CulturesResponseDTOToLocalesAdapter';

class InternationalizationRepositoryImpl implements IInternationalizationRepository {
  constructor() {
    this.GetAvailableLanguages = this.GetAvailableLanguages.bind(this);
    this.GetTranslations = this.GetTranslations.bind(this);
    this.PersistLanguage = this.PersistLanguage.bind(this);
  }

  GetAvailableLanguages(channelRelativePath: string): Promise<Locale[]> {
    return awaitDataServiceFetcher({
      payload: {
        method: 'GET',
        url: `/${channelRelativePath}/available-languages.json`,
        dataAdapter: culturesResponseDTOToLocalesAdapter,
      },
    });
  }

  GetTranslations(data: { channelRelativePath: string; locale: string }): Promise<Translation[]> {
    return awaitDataServiceFetcher({
      payload: {
        method: 'GET',
        url: `/${data.channelRelativePath}/dictionary-${data.locale}.json`,
        dataAdapter: translationsResponseDTOToTranslationsAdapter,
      },
    });
  }

  PersistLanguage(data: { language: string }): Promise<any> {
    return awaitDataServiceFetcher({
      payload: {
        method: 'POST',
        url: `/secure-web/api/private/persistLanguage`,
        data,
      },
    });
  }
}

export { InternationalizationRepositoryImpl };
